{
  "nav": {
    "linkLabel": "平台管理",
    "dashboard": "總覽",
    "users": "使用者",
    "people": "競賽",
    "judges": "評審治理",
    "admins": "平台管理員",
    "erasureRequests": "帳號刪除申請",
    "audit": "稽核紀錄",
    "competitionRequests": "競賽申請",
    "discoveryCategories": "探索分類",
    "adminGuide": "管理操作手冊",
    "toggleMenu": "選單",
    "groups": {
      "overview": "平台總覽",
      "peopleAndAccess": "人員與權限",
      "competitionGovernance": "競賽治理",
      "securityAndAudit": "安全與稽核"
    }
  },
  "erasureRequests": {
    "title": "帳號刪除申請",
    "description": "審核使用者提出的帳號刪除（GDPR 個資去識別化）申請。核准後將立即執行：帳號的姓名／Email 等識別資訊會被去識別化，登入憑證會被永久刪除；已產生的競賽歷史紀錄（投稿、分數、排名等）會保留但去識別化，以維護競賽結果完整性。此操作無法復原。",
    "listTitle": "申請列表",
    "filterStatus": "篩選狀態",
    "empty": "目前沒有符合篩選條件的申請。",
    "noReason": "（未填寫原因）",
    "columns": {
      "user": "使用者",
      "status": "狀態",
      "requestedAt": "申請時間",
      "reason": "原因",
      "actions": "操作"
    },
    "status": {
      "pending": "待審核",
      "approved": "已核准並執行",
      "rejected": "已駁回",
      "cancelled": "已取消",
      "all": "全部"
    },
    "actions": {
      "approve": "核准並執行刪除",
      "reject": "駁回"
    },
    "approveTitle": "核准並立即執行帳號刪除？",
    "approveImpact": "此帳號的姓名／Email 等識別資訊將立即被去識別化，登入憑證將被永久刪除且無法復原。已產生的競賽歷史紀錄將保留但去識別化。",
    "approveSuccess": "已核准並完成帳號刪除。",
    "rejectTitle": "駁回帳號刪除申請？",
    "rejectImpact": "使用者的帳號不受影響，仍可正常登入與使用。使用者之後可再次提出申請。",
    "rejectSuccess": "已駁回此申請。"
  },
  "discoveryCategories": {
    "title": "探索分類管理",
    "description": "平台層級的分類標籤（例如 AI、創新創業），供公開探索頁篩選使用。與各競賽自己的組別（初賽／決賽組）是完全不同的資料，互不影響。",
    "nameLabel": "名稱",
    "slugLabel": "網址代碼",
    "create": "新增分類",
    "createError": "無法建立分類。",
    "loading": "載入分類中…",
    "empty": "尚未建立任何分類。",
    "active": "使用中",
    "inactive": "已停用",
    "activate": "啟用",
    "deactivate": "停用"
  },
  "layout": {
    "loading": "載入中…",
    "title": "平台管理",
    "description": "跨競賽治理：整個平台的使用者、角色、評審與稽核紀錄。",
    "navLabel": "平台管理分頁"
  },
  "dialog": {
    "targetLabel": "對象",
    "scopeLabel": "範圍",
    "impactLabel": "預期影響",
    "reasonLabel": "原因（必填）",
    "genericError": "操作失敗，未變更任何資料。",
    "working": "處理中…",
    "scopePlatformWide": "平台全站"
  },
  "table": {
    "loading": "載入中…",
    "range": "第 {{from}}–{{to}} 筆，共 {{total}} 筆",
    "previous": "上一頁",
    "next": "下一頁",
    "exportTsv": "匯出 TSV",
    "exportExcel": "匯出 Excel"
  },
  "dashboard": {
    "loading": "載入總覽中…",
    "loadError": "無法載入平台總覽。",
    "unavailable": "暫無資料",
    "degraded": {
      "badge": "部分降級",
      "description": "部分指標本次無法計算：{{metrics}}。其餘資料仍為準確資訊。"
    },
    "actionNeeded": {
      "title": "需要你處理",
      "description": "目前偵測到的待辦事項與治理異常。",
      "empty": "目前沒有需要處理的治理事項。",
      "pendingCompetitionRequests": "{{count}} 件競賽申請待審核",
      "lastActiveSuperAdmin": "目前僅有 1 位啟用中的超級管理員，建議增加備援",
      "judgeConflicts": "偵測到評審配對衝突，需人工確認"
    },
    "groups": {
      "scale": "平台規模",
      "governance": "治理狀態",
      "health": "營運健康度"
    },
    "metrics": {
      "activeUsers": "啟用中使用者",
      "suspendedUsers": "已停權使用者",
      "totalCompetitions": "競賽總數",
      "activeCompetitions": "進行中競賽",
      "judgeRelationshipCount": "評審關係數",
      "platformAdministratorCount": "啟用中超級管理員",
      "pendingCompetitionRequests": "待處理申請",
      "competitionComposition": "{{active}} 進行中 · {{other}} 已結束／草稿",
      "registeredTeamCount": "報名隊伍數",
      "judgingCompletionRate": "評審完成率"
    },
    "recentAudit": {
      "title": "近期重要治理活動",
      "description": "跨所有競賽的重要治理操作，已預設隱藏表單欄位層級的編輯細節。",
      "empty": "暫無近期治理活動。",
      "emptyFiltered": "目前沒有重要治理活動；可切換為顯示全部活動。",
      "systemActor": "系統",
      "viewAll": "查看完整稽核紀錄 →",
      "showAll": "顯示全部活動",
      "showImportantOnly": "只顯示重要治理事件",
      "categories": {
        "identity": "身分",
        "form": "表單",
        "judging": "評審",
        "role": "角色",
        "competition": "競賽"
      }
    },
    "quickLinks": {
      "title": "快速治理入口",
      "users": "查看使用者",
      "competitionRequests": "審核競賽申請",
      "judges": "查看評審治理",
      "audit": "查看稽核"
    }
  },
  "users": {
    "title": "使用者",
    "description": "平台上所有帳號，含帳號狀態、全域角色與各競賽角色。",
    "loadError": "無法載入使用者清單。",
    "empty": "沒有符合篩選條件的使用者。",
    "filters": {
      "title": "篩選條件",
      "search": "搜尋",
      "searchPlaceholder": "姓名或 Email",
      "status": "帳號狀態",
      "role": "競賽角色",
      "any": "不限",
      "judgeOnly": "僅顯示評審",
      "judgeOnlyHint": "僅顯示具有效評審角色的使用者"
    },
    "columns": {
      "displayName": "顯示名稱",
      "email": "Email",
      "accountStatus": "帳號狀態",
      "globalRoleSummary": "全域角色",
      "competitionCount": "競賽數",
      "competitionRoleSummary": "競賽角色",
      "judgeRelationshipCount": "評審關係數",
      "createdAt": "建立時間",
      "lastActivityAt": "最後活動時間"
    }
  },
  "userDetail": {
    "loading": "載入中…",
    "loadError": "無法載入此使用者。",
    "superAdminBadge": "超級管理員",
    "tabsLabel": "使用者詳細資料分頁",
    "tabs": {
      "basic": "基本資料",
      "competitions": "競賽與角色",
      "teams": "隊伍",
      "judges": "評審",
      "security": "帳號與安全",
      "audit": "稽核歷史"
    },
    "basic": {
      "id": "使用者 ID",
      "displayName": "顯示名稱",
      "email": "Email",
      "accountStatus": "帳號狀態",
      "globalRoleSummary": "全域角色",
      "authMethodSummary": "登入方式",
      "createdAt": "建立時間",
      "lastActivityAt": "最後活動時間"
    },
    "competitions": {
      "empty": "此使用者未持有任何競賽角色。",
      "grantedAt": "授予時間：{{date}}",
      "revokeRole": "撤銷 {{role}}",
      "revokeRoleTitle": "撤銷競賽角色",
      "revokeRoleImpact": "此使用者將失去該競賽中的「{{role}}」角色。既有的隊伍／評審關係紀錄不會因此刪除。",
      "revokeSubmit": "撤銷角色",
      "revokeSuccess": "角色已撤銷。",
      "grantCompetitionSearch": "搜尋競賽名稱",
      "grantCompetitionSearchPlaceholder": "輸入競賽名稱關鍵字…",
      "grantRole": "角色",
      "grantSubmit": "授予角色",
      "grantRoleTitle": "授予競賽角色",
      "grantRoleImpact": "此使用者將被授予該競賽中的「{{role}}」角色。",
      "grantSuccess": "角色已授予。"
    },
    "teams": {
      "empty": "此使用者在任何競賽中皆無隊伍關係。"
    },
    "judges": {
      "empty": "此使用者在任何競賽中皆無評審關係。",
      "summary": "已提交 {{submitted}}/{{assignments}} 筆評分，鎖定 {{locked}} 筆，衝突 {{conflicts}} 筆"
    },
    "security": {
      "suspend": "停權使用者",
      "reactivate": "恢復使用者",
      "revokeSessions": "撤銷所有工作階段",
      "grantAdmin": "授予平台管理員",
      "revokeAdmin": "撤銷平台管理員",
      "noPermission": "您沒有管理此使用者帳號的權限。"
    },
    "dialogs": {
      "suspendImpact": "此帳號將被停權：所有進行中的工作階段將立即被撤銷，且帳號在恢復前無法登入。此操作不會刪除任何投稿、評分、結果或稽核歷史。",
      "suspendSuccess": "使用者已停權，其工作階段已被撤銷。",
      "reactivateImpact": "此帳號將被恢復，可再次登入。",
      "reactivateSuccess": "使用者已恢復。",
      "revokeSessionsImpact": "此使用者目前所有進行中的工作階段將立即被撤銷，帳號本身不會被停權。",
      "revokeSessionsSuccess": "此使用者的所有工作階段已被撤銷。",
      "grantAdminImpact": "此帳號將立即獲得平台全站的所有平台管理權限，於其下一次請求即生效。",
      "grantAdminSuccess": "已授予平台管理員權限。",
      "revokeAdminImpact": "此帳號將立即失去所有平台管理權限，於其下一次請求即生效。若此為平台最後一位啟用中的超級管理員，伺服器將拒絕此操作。",
      "revokeAdminSuccess": "已撤銷平台管理員權限。"
    },
    "audit": {
      "empty": "沒有與此使用者相關的稽核紀錄。",
      "reason": "原因：{{reason}}"
    }
  },
  "judges": {
    "title": "評審",
    "description": "每一列代表一組「使用者 × 競賽」評審關係，同一人評審兩場競賽會出現兩列。",
    "loadError": "無法載入評審清單。",
    "empty": "沒有符合篩選條件的評審關係。",
    "profileSet": "已設定檔案",
    "profileNotSet": "尚未設定檔案",
    "filters": {
      "title": "篩選條件",
      "search": "搜尋",
      "searchPlaceholder": "姓名或 Email",
      "competition": "競賽",
      "competitionPlaceholder": "輸入競賽名稱搜尋"
    },
    "columns": {
      "displayName": "顯示名稱",
      "email": "Email",
      "competition": "競賽",
      "profileStatus": "檔案狀態",
      "assignmentCount": "指派數",
      "submittedScoreCount": "已提交",
      "lockedScoreCount": "已鎖定",
      "conflictCount": "衝突數",
      "completionSummary": "完成度"
    }
  },
  "people": {
    "title": "競賽人員",
    "description": "此競賽中持有角色的所有使用者，可依角色篩選。",
    "loadError": "無法載入此競賽的人員清單。",
    "empty": "沒有符合篩選條件的人員。",
    "backToPicker": "← 選擇其他競賽",
    "judgeSummary": "已提交 {{submitted}}/{{assignments}} 筆評分",
    "picker": {
      "title": "選擇競賽",
      "description": "選擇一場競賽以查看並依角色篩選其人員。",
      "search": "搜尋",
      "searchPlaceholder": "競賽名稱或代稱",
      "empty": "沒有符合搜尋條件的競賽。",
      "loadError": "無法載入競賽清單。",
      "viewPeople": "查看人員 →"
    },
    "list": {
      "title": "競賽",
      "description": "查看平台上的競賽、狀態與治理資訊。",
      "summary": "{{total}} 場競賽 · {{active}} 場進行中 · {{draft}} 場草稿 · {{ended}} 場已結束",
      "filters": {
        "title": "篩選條件",
        "status": "狀態",
        "year": "年份",
        "any": "全部"
      },
      "columns": {
        "name": "競賽",
        "slug": "代稱",
        "status": "狀態",
        "actions": "操作"
      },
      "viewAction": "查看"
    },
    "filters": {
      "title": "篩選條件",
      "search": "搜尋",
      "searchPlaceholder": "姓名或 Email",
      "role": "角色",
      "any": "不限"
    },
    "columns": {
      "displayName": "顯示名稱",
      "email": "Email",
      "accountStatus": "帳號狀態",
      "roles": "角色",
      "team": "隊伍",
      "judge": "評審摘要",
      "grantedAt": "授予時間"
    }
  },
  "admins": {
    "title": "平台管理員",
    "description": "目前持有平台級超級管理員權限的所有帳號。",
    "loadError": "無法載入平台管理員清單。",
    "empty": "沒有符合搜尋條件的平台管理員。",
    "lastActiveAdmin": "最後一位啟用中管理員，無法撤銷",
    "filters": {
      "title": "篩選條件",
      "search": "搜尋",
      "searchPlaceholder": "姓名或 Email"
    },
    "actions": {
      "menu": "{{name}} 的操作選單",
      "viewUser": "查看使用者",
      "viewAudit": "查看相關稽核"
    },
    "columns": {
      "displayName": "顯示名稱",
      "email": "Email",
      "accountStatus": "帳號狀態",
      "grantedAt": "授予時間",
      "grantedBy": "授予者",
      "recentAudit": "近期稽核",
      "actions": "操作"
    }
  },
  "audit": {
    "title": "平台稽核",
    "description": "跨所有競賽的平台治理操作紀錄，唯讀。",
    "loadError": "無法載入稽核紀錄。",
    "empty": "沒有符合篩選條件的稽核紀錄。",
    "search": {
      "label": "搜尋本頁",
      "placeholder": "姓名、Email、操作或實體"
    },
    "filters": {
      "title": "篩選條件",
      "actorId": "操作者使用者 ID",
      "targetUserId": "對象使用者 ID",
      "competitionId": "競賽 ID",
      "action": "操作",
      "from": "起始時間",
      "to": "結束時間"
    },
    "columns": {
      "actor": "操作者",
      "action": "操作",
      "competition": "競賽",
      "entityType": "實體類型",
      "reason": "原因",
      "createdAt": "時間"
    },
    "actions": {
      "generic": "執行了「{{action}}」",
      "competitionCreate": "建立了競賽",
      "competitionUpdate": "更新了競賽資料",
      "competitionDeadlineChange": "調整了競賽截止時間",
      "competitionStatusChange": "變更了競賽狀態",
      "competitionSettingsUpdate": "更新了競賽設定",
      "categoryCreate": "建立了組別",
      "categoryUpdate": "更新了組別",
      "categoryArchive": "封存了組別",
      "roundCreate": "建立了賽程回合",
      "roundUpdate": "更新了賽程回合",
      "roundAdvancement": "執行了賽程晉級",
      "roundManualFieldCreate": "新增了輪次手動輸入欄位",
      "roundManualFieldUpdate": "修改了輪次手動輸入欄位",
      "roundManualFieldDelete": "刪除了輪次手動輸入欄位",
      "manualScoreEnter": "輸入或修改了工作人員評分",
      "formCreate": "建立了表單",
      "formUpdate": "更新了表單",
      "formArchive": "封存了表單",
      "formFieldCreate": "新增了表單欄位",
      "formFieldUpdate": "更新了表單欄位",
      "formFieldDelete": "刪除了表單欄位",
      "formFieldReorder": "調整了表單欄位順序",
      "formVersionClone": "複製了表單版本",
      "formVersionPublish": "發布了表單版本",
      "roleGrant": "授予了競賽角色",
      "roleRevoke": "撤銷了競賽角色",
      "teamChange": "調整了隊伍資料",
      "teamMemberRemove": "移除了隊伍成員",
      "teamLeaderTransfer": "轉移了隊長身分",
      "teamInviteCreate": "建立了隊伍邀請",
      "teamInviteResend": "重新寄送了隊伍邀請",
      "teamInviteRevoke": "撤銷了隊伍邀請",
      "teamInviteAccept": "接受了隊伍邀請",
      "teamRegistrationReminderSend": "傳送了報名提醒",
      "registrationNeedsUpdateReminderSend": "傳送了報名資料補填提醒",
      "registrationNeedsUpdateReminderTestSend": "寄送了報名資料補填提醒的測試信給自己",
      "submissionCreate": "建立了投稿",
      "submissionUpdate": "更新了投稿",
      "submissionSubmit": "送出了投稿",
      "submissionLock": "鎖定了投稿",
      "submissionUnlock": "解鎖了投稿",
      "submissionWithdraw": "撤回了投稿",
      "submissionDisqualify": "取消了投稿資格",
      "submissionReinstate": "復原了投稿資格",
      "submissionReturnForCorrection": "退回投稿以要求修正",
      "fileUploadComplete": "完成了檔案上傳",
      "fileUploadFailed": "回報了一次上傳失敗",
      "fileDelete": "刪除了檔案",
      "judgeInvitationDecline": "婉拒了評審邀請",
      "judgeAutoReminderUpdate": "變更了評審自動提醒設定",
      "judgeWithdrawal": "退出了評審工作",
      "judgeAcknowledgement": "確認了評審須知",
      "judgeReminderSend": "寄送了評審進度提醒",
      "judgeAssignment": "指派了評審",
      "judgeReassignment": "重新指派了評審",
      "scoreSubmit": "提交了評分",
      "scoreReopen": "重新開放了評分",
      "scoreChange": "變更了評分",
      "resultCalculate": "計算了結果",
      "resultLock": "鎖定了結果",
      "resultPublish": "發布了結果",
      "resultOverride": "覆寫了結果",
      "announcementPublish": "發布了公告",
      "announcementUpdate": "編輯了公告",
      "announcementDelete": "刪除了公告",
      "announcementEmailSend": "以 Email 寄送了公告",
      "announcementEmailTestSend": "寄送了公告 Email 的測試信給自己",
      "notificationEmailDelivery": "系統寄出了通知信（記錄寄送結果）",
      "authLogin": "登入平台",
      "authLogout": "登出平台",
      "authLoginLocked": "因登入失敗次數過多被鎖定帳號",
      "authRegister": "註冊了帳號",
      "authPasswordReset": "重設了密碼",
      "initialSuperAdminBootstrap": "完成了初始超級管理員設定",
      "userSuspend": "停權了使用者",
      "userReactivate": "恢復了使用者",
      "userSessionsRevoke": "撤銷了使用者的工作階段",
      "superAdminGrant": "授予了平台管理員權限",
      "superAdminRevoke": "撤銷了平台管理員權限",
      "judgeInvitationCreate": "建立了評審邀請",
      "judgeInvitationCancel": "取消了評審邀請",
      "judgeInvitationResend": "重新寄送了評審邀請",
      "authForcedPasswordChangeComplete": "完成了強制首次登入改密碼",
      "competitionRequestSubmit": "送出了競賽申請",
      "competitionRequestCancel": "取消了競賽申請",
      "competitionRequestRequestChanges": "要求補件",
      "competitionRequestReject": "拒絕了競賽申請",
      "competitionRequestApprove": "核准了競賽申請",
      "profileSelfUpdate": "更新了自己的個人資料",
      "authPasswordChange": "變更了自己的密碼",
      "authEmailChangeRequested": "提出了 Email 變更請求",
      "authEmailChangeVerified": "變更了自己的 Email",
      "sessionSelfRevoke": "撤銷了自己的工作階段",
      "platformDiscoveryCategoryCreate": "建立了探索分類",
      "platformDiscoveryCategoryUpdate": "更新了探索分類",
      "eligibilityPolicyUpdate": "更新了學生資格驗證政策",
      "eligibilityProofUploadComplete": "上傳了在學證明",
      "eligibilityProofReplace": "重新上傳了在學證明",
      "eligibilityVerificationApproved": "通過了學生資格驗證",
      "eligibilityVerificationRejected": "駁回了學生資格驗證",
      "eligibilityProofRetentionDelete": "系統自動刪除了到期的在學證明檔案",
      "accountErasureRequested": "提出了帳號刪除申請",
      "accountErasureCancelled": "取消了帳號刪除申請",
      "accountErasureRejected": "駁回了帳號刪除申請",
      "accountErasureExecuted": "執行了帳號刪除（個資去識別化）",
      "dataExportDownloaded": "匯出了個人資料",
      "adminReportExport": "匯出了競賽報表",
      "competitionConfigExport": "匯出了競賽設定",
      "competitionClone": "複製了競賽",
      "templateCreate": "建立了競賽範本",
      "templateRevisionCreate": "更新了競賽範本",
      "templateCreateCompetition": "從範本建立了競賽",
      "configImportCreate": "從 JSON 匯入了競賽"
    }
  },
  "competitionRequests": {
    "title": "競賽申請",
    "description": "審核一般使用者提出的主辦競賽申請。核准後系統會自動建立競賽並授予申請人管理員權限，不需另外手動建立競賽或指派管理員。",
    "loadError": "無法載入申請清單。",
    "empty": "沒有符合篩選條件的申請。",
    "filters": {
      "title": "篩選條件",
      "status": "狀態",
      "any": "不限"
    },
    "tabs": {
      "all": "全部"
    },
    "columns": {
      "proposedName": "提案競賽名稱",
      "organization": "主辦單位",
      "contactPerson": "聯絡人",
      "status": "狀態",
      "submittedAt": "送出時間",
      "actions": "操作"
    },
    "detail": {
      "loading": "載入中…",
      "loadError": "無法載入此申請。",
      "backToList": "← 回到競賽申請",
      "applicantSection": "申請內容",
      "governanceSection": "治理相關資訊",
      "reviewSection": "審核歷史",
      "fields": {
        "proposedName": "提案競賽名稱",
        "proposedSlug": "提案網址代稱",
        "organization": "主辦單位",
        "contactPerson": "聯絡人",
        "contactEmail": "聯絡 Email",
        "description": "競賽目的與說明",
        "timezone": "時區",
        "expectedStartAt": "預計開始時間",
        "expectedEndAt": "預計結束時間",
        "expectedParticipants": "預計參賽人數",
        "judgingRequired": "需要評審評分",
        "twoRoundRequired": "需要兩階段賽程",
        "studentMinorData": "涉及學生／未成年人資料",
        "notes": "其他備註",
        "submittedAt": "送出時間",
        "reviewerUserId": "審核者 ID",
        "reviewedAt": "審核時間",
        "reviewReason": "審核原因",
        "createdCompetitionId": "已建立競賽 ID"
      },
      "yes": "是",
      "no": "否",
      "none": "無"
    },
    "actions": {
      "review": "審核",
      "view": "查看",
      "viewResult": "查看結果",
      "startReview": "開始審核",
      "startReviewSuccess": "已開始審核此申請。",
      "requestChanges": "要求補件",
      "requestChangesImpact": "申請人將看到您填寫的補件原因，可重新提出申請。此申請本身不會被拒絕或核准。",
      "requestChangesSuccess": "已要求申請人補件。",
      "reject": "拒絕申請",
      "rejectImpact": "此申請將被標記為已拒絕，不會建立競賽。申請人可看到拒絕原因。",
      "rejectSuccess": "已拒絕此申請。",
      "approve": "核准並建立競賽",
      "approveImpact": "核准後系統會立即建立正式競賽、建立預設賽程設定，並自動授予申請人該競賽的第一位管理員角色 — 不需要再手動建立競賽或指派管理員。",
      "approveSuccess": "已核准申請並建立競賽。",
      "alreadyProvisioned": "此申請先前已核准並建立競賽，本次未重複建立。",
      "viewCompetition": "查看已建立的競賽 →",
      "noPermission": "您沒有審核競賽申請的權限。"
    }
  }
}
